import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { postData } from "../utility/Utility";

function Header() {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSidebarHidden, setIsSidebarHidden] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [profileData, setProfileData] = useState(null);

  // Function to toggle user dropdown
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };


useEffect(() => {
  const fetchProfile = async () => {
    try {
      const response = await postData("api/admin/profile");
      if(response?.success) {
        setProfileData(response.data);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };
  
  fetchProfile();
}, []);


  const handleLogout = async () => {
    localStorage.clear("");
    navigate("/");
  };



  const toggleSidebar = () => {
    setIsSidebarHidden(!isSidebarHidden);
  };

  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Set initial sidebar state based on window width
    if (windowWidth < 974) {
      setIsSidebarHidden(true);
    } else {
      setIsSidebarHidden(false);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  useEffect(() => {
    // Apply the sidebar state to the body attribute
    const body = document.body;
    if (isSidebarHidden) {
      body.setAttribute("data-sidebar", "hidden");
    } else {
      body.removeAttribute("data-sidebar");
    }
  }, [isSidebarHidden]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector('.profile-dropdown');
      const toggleButton = document.querySelector('.dropdown-toggle.nav-user');
      
      if (isDropdownOpen && 
          !dropdown.contains(event.target) && 
          !toggleButton.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="topbar-custom">
      <div className="container-fluid">
        <div className="d-flex justify-content-between">
          <ul className="list-unstyled topnav-menu mb-0 d-flex align-items-center">
            <li>
              <button
                type="button"
                onClick={toggleSidebar}
                className="button-toggle-menu nav-link"
              >
                <i className="fas fa-bars"></i>
              </button>
            </li>
          </ul>

          <ul className="list-unstyled topnav-menu mb-0 d-flex align-items-center">



            {/* User Dropdown */}
            <li className="dropdown notification-list topbar-dropdown">
              <a
                className="nav-link dropdown-toggle nav-user me-0"
                onClick={toggleDropdown}
                role="button"
                aria-haspopup="true"
                aria-expanded={isDropdownOpen}
              >
                {/* <img
                  src="./assets/images/users/user-13.jpg"
                  alt="user-image"
                  className="rounded-circle"
                /> */}
                <span className="pro-user-name ms-1">
                  {profileData?.username} <i className="fas fa-chevron-down"></i>
                </span>
              </a>

              <div
                className={`dropdown-menu dropdown-menu-end profile-dropdown ${isDropdownOpen ? "show profileshow" : ""
                  }`}
              >
                <div className="dropdown-header noti-title">
                  <h6 className="text-overflow m-0">Welcome !</h6>
                </div>

                <Link
                  className="dropdown-item notify-item"
                  to="/admin-profile"
                >
                  <i className="fas fa-user-circle"></i>
                  <span>My Account</span>
                </Link>

                <Link
                  className="dropdown-item notify-item"
                  to="auth-lock-screen.html"
                >
                  <i className="fas fa-lock"></i>
                  <span>Lock Screen</span>
                </Link>

                <div className="dropdown-divider"></div>

                <div
                  className="dropdown-item notify-item"
                  onClick={handleLogout}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fas fa-sign-out-alt"></i>
                  <span>Logout</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Header;